<script lang='ts'>
	import { c } from '../../ts/managers/Configuration';
	import Panel from './Panel.svelte';
	c.configure();
</script>
<Panel/>

<!-- I apologize, this app is under heavy reconstruction... -->